import React from 'react';
import { motion } from 'framer-motion';
import { Facilities } from '../components/Facilities';
export function Equipment() {
  const equipmentList = [{
    name: 'High speed infrared camera',
    model: 'FLIR X6900sc MWIR',
    image: 'https://images.unsplash.com/photo-1516387938699-a93567ec168e?auto=format&fit=crop&q=80&w=600'
  }, {
    name: 'Infrared Camera',
    model: 'FLIR A655sc (Quantity: 2 Nos)',
    image: 'https://images.unsplash.com/photo-1502920917128-1aa500764cbd?auto=format&fit=crop&q=80&w=600'
  }, {
    name: 'FLIR IR Lenses',
    model: 'MWIR 4215500, MWIR 4214995, T198066, T198065',
    image: 'https://images.unsplash.com/photo-1617005082833-1eb5857038e5?auto=format&fit=crop&q=80&w=600'
  }, {
    name: 'High Speed Camera',
    model: 'Phantom VEO 3',
    image: 'https://images.unsplash.com/photo-1512790182412-b19e6d62bc39?auto=format&fit=crop&q=80&w=600'
  }];
  return <div className="bg-[#FAF9F7] min-h-screen pb-24" data-id="element-316">
      <div className="bg-[#4A0000] py-16 text-center" data-id="element-317">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-4xl md:text-5xl font-bold text-white font-serif" data-id="element-318">
          Equipment & Facilities
        </motion.h1>
      </div>

      <Facilities data-id="element-319" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-16" data-id="element-320">
        <h2 className="text-3xl font-bold text-[#800000] font-serif mb-12 text-center" data-id="element-321">
          Major Instruments
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-322">
          {equipmentList.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 text-center hover:shadow-md transition-shadow" data-id="element-323">
              <div className="h-40 mb-6 flex items-center justify-center overflow-hidden rounded-lg bg-gray-50" data-id="element-324">
                <img src={item.image} alt={item.name} className="max-h-full object-contain mix-blend-multiply" data-id="element-325" />
              </div>
              <h3 className="font-bold text-gray-900 font-serif mb-2" data-id="element-326">
                {item.name}
              </h3>
              <p className="text-sm text-gray-600" data-id="element-327">{item.model}</p>
            </motion.div>)}
        </div>
      </div>
    </div>;
}